export const consolidated = {
	excelButton: "Export to Excel",
	extract: "Extract",
	filename: "extract-zig",
	table: {
		section: "Section",
		name: "Name",
		totalValue: "Total Value",
		fee: "Fee",
		feeMin: "Minimum Fee",
		feeMax: "Maximum Fee",
		payValue: "Receivable/Payable Zig",
	},
	formatFee: "From {{minFee}} to {{maxFee}}",
};
